import {
  BehaviorSignalElementBlock as RecordingBehaviorSignalElementBlock,
  BehaviorSignalType,
  KeepRule,
} from '@fullstory/proto/fs/services/ingestion-settings';

enum IngestionSettingsTypes {
  FetchBehaviorSignalSettingsRequest = 'ingestionSettings.fetchBehaviorSignalSettingsRequest',
  FetchBehaviorSignalSettingsSuccess = 'ingestionSettings.fetchBehaviorSignalSettingsSuccess',
  FetchBehaviorSignalSettingsFailure = 'ingestionSettings.fetchBehaviorSignalSettingsFailure',
  CreateBehaviorSignalSettingsRequest = 'ingestionSettings.createBehaviorSignalSettingsRequest',
  CreateBehaviorSignalSettingsSuccess = 'ingestionSettings.createBehaviorSignalSettingsSuccess',
  CreateBehaviorSignalSettingsFailure = 'ingestionSettings.createBehaviorSignalSettingsFailure',
  DeleteBehaviorSignalSettingsRequest = 'ingestionSettings.deleteBehaviorSignalSettingsRequest',
  DeleteBehaviorSignalSettingsSuccess = 'ingestionSettings.deleteBehaviorSignalSettingsSuccess',
  DeleteBehaviorSignalSettingsFailure = 'ingestionSettings.deleteBehaviorSignalSettingsFailure',
  UpdateBehaviorSignalSettingsRequest = 'ingestionSettings.updateBehaviorSignalSettingsRequest',
  UpdateBehaviorSignalSettingsSuccess = 'ingestionSettings.updateBehaviorSignalSettingsSuccess',
  UpdateBehaviorSignalSettingsFailure = 'ingestionSettings.updateBehaviorSignalSettingsFailure',
  FetchRecordingFeaturesRequest = 'ingestionSettings.fetchRecordingFeaturesRequest',
  FetchRecordingFeaturesSuccess = 'ingestionSettings.fetchRecordingFeaturesSuccess',
  FetchRecordingFeaturesFailure = 'ingestionSettings.fetchRecordingFeaturesFailure',
  UpdateClientSideRageClickRequest = 'ingestionSettings.updateClientSideRageClickRequest',
  UpdateClientSideRageClickSuccess = 'ingestionSettings.updateClientSideRageClickSuccess',
  UpdateClientSideRageClickFailure = 'ingestionSettings.updateClientSideRageClickFailure',
  FetchKeepRulesRequest = 'ingestionSettings.fetchKeepRulesRequest',
  FetchKeepRulesSuccess = 'ingestionSettings.fetchKeepRulesSuccess',
  FetchKeepRulesFailure = 'ingestionSettings.fetchKeepRulesFailure',
  UpdateDefaultPrivacyModeRpcRequest = 'ingestionSettings.updateDefaultPrivacyModeRpcRequest',
  UpdateDefaultPrivacyModeRpcSuccess = 'ingestionSettings.updateDefaultPrivacyModeRpcSuccess',
  UpdateDefaultPrivacyModeRpcFailure = 'ingestionSettings.updateDefaultPrivacyModeRpcFailure',
  FetchDetectionsConfigRulesRequest = 'ingestionSettings.fetchDetectionsConfigRulesRequest',
  FetchDetectionsConfigRulesSuccess = 'ingestionSettings.fetchDetectionsConfigRulesSuccess',
  FetchDetectionsConfigRulesFailure = 'ingestionSettings.fetchDetectionsConfigRulesFailure',
  UpdateDetectionsConfigRulesRequest = 'ingestionSettings.updateDetectionsConfigRulesRequest',
  UpdateDetectionsConfigRulesSuccess = 'ingestionSettings.updateDetectionsConfigRulesSuccess',
  UpdateDetectionsConfigRulesFailure = 'ingestionSettings.updateDetectionsConfigRulesFailure',
  ValidateBlockedIpRuleRequest = 'ingestionSettings.validateBlockedIpRuleRequest',
  ValidateBlockedIpRuleSuccess = 'ingestionSettings.validateBlockedIpRuleSuccess',
  ValidateBlockedIpRuleFailure = 'ingestionSettings.validateBlockedIpRuleFailure',
  GetDomainSettingsRequest = 'ingestionSettings.getDomainSettingsRequest',
  GetDomainSettingsSuccess = 'ingestionSettings.getDomainSettingsSuccess',
  GetDomainSettingsFailure = 'ingestionSettings.getDomainSettingsFailure',
}

interface KeepRuleWithId extends KeepRule {
  id: string;
}

export interface KeepRuleSetWithId {
  rules: KeepRuleWithId[];
}

const BehaviorSignalTypeArray = [
  BehaviorSignalType.SIGNAL_RAGE_CLICK,
  BehaviorSignalType.SIGNAL_DEAD_CLICK,
];

export { IngestionSettingsTypes, BehaviorSignalTypeArray };

export interface BehaviorSignalElementBlock
  extends Omit<RecordingBehaviorSignalElementBlock, 'selector'> {
  name: string;
  selectors: string[];
}

// Converts solely for action purposes. Carries over the minimal set of properties required to issue requests.
export const toRecordingBehaviorSignalElementBlock = (
  elementBlock: BehaviorSignalElementBlock,
): RecordingBehaviorSignalElementBlock =>
  elementBlock.namedElementId
    ? {
        namedElementId: elementBlock.namedElementId,
        selector: '',
        notes: '',
        signals: elementBlock.signals,
      }
    : {
        namedElementId: '',
        selector: elementBlock.selectors[0] ?? '',
        notes: elementBlock.notes,
        signals: elementBlock.signals,
      };
